import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../environments/environment';
import {LmsHeaderCommonService} from '../shared/common-components/lms-header/service/lms-header-common.service';
import {GlobalConstants} from '../shared/global-constants';
import {CommonService} from '../shared/common.service';
import {UserData} from '../shared/common-components/lms-header/service/lms-header-common.model';
import {TokenService} from '../core/token.service';
import {UserAuthoritiesService} from '../shared/user';


@Component({
  selector: 'app-landing-component',
  templateUrl: './landing-component.component.html',
  styleUrls: ['./landing-component.component.scss'],
})

export class LandingPageComponent {

  constructor(
    private readonly router: Router,
    private readonly activedRoute: ActivatedRoute,
    private readonly lmsHeaderCommonService: LmsHeaderCommonService,
    private readonly service: CommonService,
    private readonly tokenService: TokenService,
    private readonly userAuthoritiesService: UserAuthoritiesService,
  ) {
    localStorage.setItem(GlobalConstants.LOGIN_TIME, this.service.encrypt(`${''}${Date.now()}`));
    localStorage.setItem(GlobalConstants.REFRESH_TIME, this.service.encrypt(`${''}${Date.now() + GlobalConstants.REFRESH_TIME_VALUE}`));
    this.activedRoute.paramMap.subscribe((par: any) => {
      if (!par.params.id) {
        localStorage.setItem(GlobalConstants.REDIRECT_URL, environment.redirectUrl);
        window.open(
          `${window.location.origin}/assets/logout.html`,
          '_self'
        );
      }
      const token = par.params.id;
      this.tokenService.setToken(token);
      localStorage.setItem(GlobalConstants.TOKEN, token);
      this.getUserById();
      this.userAuthoritiesService.clearCache();
    });
  }

  getUserById(): void {
    setTimeout(() => {
      if (this.tokenService.hasToken()) {
        this.lmsHeaderCommonService
          .getLoggedUser()
          .subscribe((res: UserData) => {
            localStorage.setItem(GlobalConstants.REDIRECT_URL, environment.redirectUrl);
            // TODO LRAS-2093: Server encryption and frontend decryption don't work together; this needs fixing
            localStorage.setItem(GlobalConstants.ASSIGNED_OU_LIST, this.service.encrypt(res.attributes.assignedOUList));
            this.router.navigate(['dashboard']);
          });
      }
    }, 2000);
  }
}


